import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { YotpoIcon as Component } from '@yotpo-common/ui-components/components/icon';

export const YotpoIcon = createComponent({
	react: React,
	tagName: 'yotpo-icon',
	elementClass: Component
});
